/**
 * Spades virtual currency pricing tiers.
 *
 * Spades (♠) are Polar Ace's virtual currency used to interact
 * with streamers via the "Go Live!" feature.
 *
 * Pricing follows a volume discount model — larger purchases
 * offer slightly better value per spade.
 */

export const SPADES_TIERS = [
  { id: 1, amount: 2500, display: '2,500 Spades', price: 4.99 },
  { id: 2, amount: 5000, display: '5,000 Spades', price: 9.98 },
  { id: 3, amount: 12500, display: '12,500 Spades', price: 24.95 },
  { id: 4, amount: 25000, display: '25,000 Spades', price: 49.90 },
  { id: 5, amount: 50000, display: '50,000 Spades', price: 99.80 },
];

/**
 * Format price for display with currency symbol.
 * @param {number} price - Price in dollars
 * @returns {string} Formatted price string
 */
export const formatPrice = (price) => `$${price.toFixed(2)}`;

/**
 * Format spades count with abbreviations for large numbers.
 * @param {number} count - Number of spades
 * @returns {string} Formatted spades string (e.g., "50K", "1.2M")
 */
export const formatSpades = (count) => {
  if (count >= 1_000_000) {
    return `${(count / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (count >= 1_000) {
    return `${(count / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return count.toString();
};
